import { ref, watch } from 'vue'
import BaseModal from '@/components/ui/modals/BaseModal'

const modals = ref([])

export default BaseModal

export const useModalController = (key, modalRef, scroll) => {
    const { modal } = useModal({ key: key })

    watch(
        () => modalRef.value,
        (modalRef) => {
            if (modalRef) {
                if (scroll) {
                    _scrollToTop()
                }

                if (Array.isArray(modalRef)) {
                    modalRef[0].focus()
                } else {
                    modalRef.focus()
                }
            }
        },
        { deep: true }
    )
    function _scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    function openModal(e) {
        if (e) e.preventDefault()
        document.body.classList.add('modal-open')
        setTimeout(() => {
            modal.value.show = true
        }, modal.timer * 1000)
    }
    function closeModal(e) {
        if (e) e.preventDefault()
        modal.value.show = false
        document.body.classList.remove('modal-open')
    }

    return {
        openModal,
        closeModal
    }
}

export const useModal = ({ key, timer, base }) => {
    if (base) {
        if (modals.value.some((modal) => modal.key === key)) {
            throw new Error('Please pass in an unique modal key string.')
        }
        const modalRef = ref(null)
        modals.value.push(
            ref({
                key: key,
                ref: modalRef,
                show: false,
                timer: timer ?? 0
            })
        )
    }

    const modal = modals.value.find((modal) => modal.value.key === key)

    return {
        modal
    }
}
